const _ = require('underscore/underscore-min');
const Utils = require('core-helpers/utils.js');
const PurchaseService = require('purchase/purchase-service.js');
const ExceptionService = require('exceptions/exception-service.js');
const PlansService = require('premium/plans-service.js');

const CardPlansController = (function(root, doc, undefined) {

    'use strict';

    /**
     * Private vars
     */
    const filename = 'card-plans-controller.js';
    const plansElement = Utils.getById('card-plans');
    const plansElementError = Utils.getById('card-plans-error');
    const disabledCardClasses = 'card-plans__item--disabled';
    const loadingClasses = 'card-plans__list--loading main-spinner-a main-spinner--l-a main-spinner--brand-a';
    let plansData = null;

    const onCodeFailure = (e) => {
        ExceptionService.handle('error', {
            filename: filename,
            data: e
        });
        onError();
    };

    /**
     * Toggle/hide plans loader
     */
    const showLoader = () => {
        if (plansElement) {
            Utils.addClass(plansElement, loadingClasses);
        }
    };

    const hideLoader = () => {
        if (plansElement) {
            Utils.removeClass(plansElement, loadingClasses);
        }
    };

    const getTranslation = (key) => {
        return root.BUSUU_TRANSLATIONS[key] || 'TRS NOT FOUND';
    };

    /**
     * Returns plan URL
     * @return {String || null}
     */
    const getPlansURL = () => {
        let successURL = plansElement.getAttribute('data-success');
        if (successURL && PlansService.isUserAuthenticated(plansData)) {
            return successURL.replace('{course}', plansData.learning_default);
        }
        return plansElement.getAttribute('data-failure') || null;
    };

    /**
     * Return a plan title based on a given plan months
     * @param  {Object} plan
     * @return {String}
     */
    const getPlanTitle = (months) => {
        const trs = months === 1 ? '1_MONTH' : months + '_MONTHS';
        return getTranslation(trs);
    };

    const getPlanElement = (month) => {
        if (!month) {
            return null;
        }
        month = month.toString();
        return plansElement.querySelector(`[data-months="${ month }"]`) || null;
    };

    const addPlanData = (element, plan) => {
        element.href = getPlansURL();
        element.setAttribute('data-plan-id', plan.planID);
        element.setAttribute('data-total-price', plan.totalPrice);
        if (plan.hasDiscount) {
            element.setAttribute('data-discount', plan.discountPercent);
            element.setAttribute('data-total-discount-price', plan.totalDiscountPrice);
            element.setAttribute('data-total-price-after-discount', plan.totalPriceAfterDiscount);
        }
    };

    const displayPlanData = (element, plan) => {
        if (plan.hasDiscount) {
            const originalPriceElement = Utils.getElementByClass('js-original-price', element);
            const discountElement = Utils.getElementByClass('js-plan-discount', element);
            const savingElement = Utils.getElementByClass('js-saving-percent', element);

            const discountText = getTranslation('X_PERCENT').replace('%s', plan.discountPercent);
            const savingText = getTranslation('SAVE_X_PERCENT').replace('%s', plan.discountPercent);

            Utils.removeClass(discountElement, 'card-plans__discount--hide');
            Utils.setText(originalPriceElement, plan.monthlyPrice);
            Utils.setText(discountElement, discountText);
            Utils.setText(savingElement, savingText);

        }

        const monthlyPrice = plan.hasDiscount ? plan.monthlyPriceAfterDiscount : plan.monthlyPrice;
        const monthlyPriceElement = Utils.getElementByClass('js-monthly-price', element);
        Utils.setText(monthlyPriceElement, monthlyPrice);

    };

    const showPlan = (element) => {
        Utils.removeClass(element, disabledCardClasses);
    };

    const setupPlan = (element, plan) => {
        displayPlanData(element, plan);
        addPlanData(element, plan);
        showPlan(element);
    };

    const onPlanClick = function(e) {

        const onSuccess = () => {
            root.location.href = this.href;
        };

        // If the session is expired we reload to get a fresh one
        const onError = (e) => {
            root.location.reload();
        };

        e.preventDefault();
        showLoader();

        PlansService.verifySessionAndStorePlan(plansData, this).then(onSuccess).catch(onError).done();

    };

    const displayAllPlans = (plansData) => {

        const plans = _.filter(plansData.plans, (plan) => {
            const formattedPlan = PlansService.getFormattedPlan(plan);
            const planElement = getPlanElement(formattedPlan.months);
            if (planElement) {
                setupPlan(planElement, formattedPlan);
            }
            return planElement ? true : false;
        });

        if (!plans.length) {
            return onCodeFailure('0 plans found.');
        }

        /**
         * If the user is authenticated,
         * we need a click handler on each plans to
         * add severals steps before going to the cart.
         */
        if (PlansService.isUserAuthenticated(plansData)) {
            Utils.delegate(plansElement, 'js-plan', 'click', onPlanClick);
        }

    };

    const onSuccess = (data) => {
        plansData = Utils.deepClone(data);
        displayAllPlans(plansData);
    };

    const onError = () => {
        Utils.hide(plansElement);
        Utils.removeClass(plansElementError, 'hide');
    };

    const fetchPlans = () => {
        showLoader();
        PurchaseService.getPlans().then(onSuccess).catch(onError).finally(hideLoader).done();
    };

    const init = () => {
        if (plansElement) {
            fetchPlans();
        }
    };

    init();

})(window, document);

module.exports = CardPlansController;
